export const ActionKeys = {
	// Atlassian Projects
	CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
	// Jira
	UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
	UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
	TriageApplyRecommendationTool: 'TriageApplyRecommendationTool',
	JiraFindIssues: 'jira-find-issues',
	JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
	JiraSmartIssueCreateBulk: 'jira-atlassian-work-item-create-all-field-types-bulk',
	JiraAdminAgent: 'JiraAdminAgentActionableTool',
	JiraAdminFieldTrash: 'JiraAdminFieldTrashActionableTool',
	JiraAdminFieldMerge: 'JiraAdminFieldMergeActionableTool',
	JiraIssueTransition: 'jira-issue-transition-bulk',
	JiraEpicsSuggest: 'jira-epics-suggest',
	JiraIssueDelete: 'jira-issue-delete',
	JiraIssueMove: 'jira-issue-move',
	JiraIssueAssign: 'jira-issue-assign-bulk',
	JiraVersionCreate: 'jira-version-create',
	JiraViewCreateAndConfigure: 'jira-view-create-and-configure',
	JiraViewSaveListViewConfig: 'jira-view-save-list-view-config',
	RovoWhenAssignedTool: 'RovoWhenAssignedTool',
	RovoJiraDelegationIntentTool: 'RovoJiraDelegationIntentTool',
	// Work organizer sprint actions
	JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
	JiraStartSprint: 'jira-atlassian-board-start-sprint',
	JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
	JiraWorkflowEditor: 'jira-workflow-operations',
	// Confluence
	ConfluenceFolderCreate: 'confluence-atlassian-workspace-create-folder',
	ConfluencePageCreate: 'confluence-page-create',
	ConfluencePageComment: 'confluence-page-comment',
	ConfluenceComment: 'confluence-comment', // Comments on content other than pages and blog posts, such as whiteboards
	ConfluencePageAddLabel: 'confluence-label-create',
	ConfluencePageAddLabelIS: 'confluence-atlassian-workspace-create-label', // Integration Service tool name variant
	ConfluencePageRename: 'confluence-page-rename',
	ConfluencePageMove: 'confluence-page-move',
	// Confluence approval action keys emitted by Integration Service.
	ConfluenceApprovalCreate: 'confluence-atlassian-document-create-approval',
	ConfluenceApprovalDelete: 'confluence-atlassian-document-delete-approval',
	ConfluenceApprovalGet: 'confluence-atlassian-document-get-approval',
	ConfluenceApprovalGetHistory: 'confluence-atlassian-document-get-approval-history',
	ConfluenceApprovalUpdateCancel: 'confluence-atlassian-document-update-approval-cancel',
	ConfluenceApprovalUpdateDecision: 'confluence-atlassian-document-update-approval-decision',
	ConfluenceApprovalUpdateDueDate: 'confluence-atlassian-document-update-approval-due-date',
	ConfluenceApprovalUpdateMessage: 'confluence-atlassian-document-update-approval-message',
	ConfluenceApprovalUpdateReviewerMembership:
		'confluence-atlassian-document-update-approval-reviewer-membership',
	ConfluenceApprovalUpdateReviewers: 'confluence-atlassian-document-update-approval-reviewers',
	// Convo AI and CAP LongHorizon approval action keys.
	ConfluenceApprovalCreateConvoAi: 'confluence-approval-create',
	ConfluenceApprovalReviewApprove: 'confluence-approval-review-approve',
	ConfluenceApprovalReviewDeny: 'confluence-approval-review-deny',
	ConfluenceApprovalReviewCancel: 'confluence-approval-review-cancel',
	ConfluenceApprovalReviewClear: 'confluence-approval-review-clear',
	ConfluenceApprovalReviewersUpdate: 'confluence-approval-reviewers-update',
	ConfluenceApprovalMessageUpdate: 'confluence-approval-message-update',
	ConfluenceApprovalDueDateUpdate: 'confluence-approval-due-date-update',
	ConfluenceApprovalSpaceSettingsUpdate: 'confluence-approval-space-settings-update',
	ConfluenceApprovalSiteSettingsUpdate: 'confluence-approval-site-settings-update',
	// JSM
	JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
	JsmCreateRequest: 'jsm-create-request',
	JsmCreateRequestV2: 'jsm-create-request-v2',
	CreateRequest: 'create-request',
	JsmCreateEmbeddedRequest: 'help-form-submit',
	JsmCreateSurvey: 'jsm-create-survey',
	JsmCreateFormTemplate: 'jsm-atlassian-project-create-form-template',
	JsmLivechat: 'jsm-livechat',
	JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
	// Deep Research
	DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
	// Studio
	StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
	StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
	StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
	StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
	StudioAutomationCreateRule: 'automation-platform-atlassian-automation-create-rule',
	UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
	StudioCreateAgent: 'CreateAgentTool',
	RovoPublishAgent: 'rovo-publish-agent',
	StudioLandingPageRedirect: 'studio-landing-page-redirect',
	// Plans — canonical keys; keep in sync with the JIRA_PLANS_*_KEY constants below.
	JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
	JiraPlansCreateProgramBoard: 'jira-atlassian-plan-add-program-board',
	JiraPlansDeleteProgramBoard: 'jira-atlassian-plan-delete-program-board',
	JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
	JiraPlansCreateRelease: 'jira-atlassian-plan-create-release',
	JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
	JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
	JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
	// Capacity Planning
	ManageCapacityPlan: 'capacity-plan-update-single-action',
	// Allocation Planning
	ManagePlanAllocations: 'manage-plan-allocations',
	// Atlassian Teams
	AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
	// Focus Asks
	FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
	FocusCreateAskAnthropic: 'ari:cloud:platform::skill/b3f8a1c2-7e4d-4a9b-8c6f-2d1e5b9a3f7es',
	// Bitbucket
	BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
	// Slack
	SlackSendChannelMessage: 'slack-send-channel-message',
	// Others
	StoreRecommendationCard: 'store-recommendation-card',
	RequireInformationTool: 'RequireInformationTool',
	HiringManagerTool: 'HiringManagerTool',
	JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
	JsmAtlassianProjectCreateJsmRequestType: 'jsm-atlassian-project-create-jsm-request-type',
	JsmAtlassianProjectCreateJsmRequestTypeWithFields:
		'jsm-atlassian-project-create-jsm-request-type-with-fields',
	// Google Docs
	GoogleDocCreate: 'google-doc-create',
	// Convo AI agent tools
	ExecutePython: 'execute_python',
	PlanComplete: 'plan_complete',
	AskQuestion: 'ask_question',
	JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
	JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
	JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
	JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
	JsmAtlassianProjectUpdateRequestTypePortalGroups:
		'jsm-atlassian-project-update-request-type-groups',
	JsmAtlassianRequestTypeUpdateWorkflow: 'jsm-atlassian-request-type-update-workflow',
	JsmSelectHardwareTypes: 'ham-onboarding-hardware-assets-types',
	JsmSelectHardwareTypesSkill: 'ham-onboarding-hardware-assets-types-skill',
	HamOnboardingSetupComplete: 'ham-onboarding-setup-complete',
	HamOnboardingSetupCompleteSkill: 'ham-onboarding-setup-complete-skill',
	// Solution Composer SLA-plugin keys (fire-and-forget staging + embed-view routing).
	JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
	JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
	// Bare `manage-sla` skill keys (Rovo Chat SLA create/update card). Distinct from the
	// Solution Composer plugin keys above — see jira `useSlaSavedBridge`.
	JsmCreateSla: 'jsm-create-sla',
	JsmUpdateSla: 'jsm-update-sla',
	// Confluence AIFC
	AifcAdfUpdate: 'aifc-adf-update',
	// AdminHub policy platform
	AdminhubPolicyCreate: 'atlassian:admin:create:policy-preview',
	AdminhubPolicyUpdate: 'atlassian:admin:update:policy-preview',
	// Google Calendar
	GoogleCalendarEventCreate: 'google-calendar-event-create',
	// Assets
	AssetsCreateSchema: 'assets-create-schema',
	AssetsSchemaCreateObjectType: 'assets-schema-create-object-type',
	AssetsObjectTypeCreateAttribute: 'assets-object-type-create-attribute',
	AssetsObjectTypeCreateObject: 'assets-object-type-create-object',
	AssetsObjectTypeCreateObjectBulk: 'assets-object-type-create-object-bulk',
	AssetsObjectCreateAttribute: 'assets-object-create-attribute',
	AssetsUpdateSchema: 'assets-update-schema',
	AssetsSchemaUpdateObjectType: 'assets-schema-update-object-type',
	AssetsObjectTypeUpdateAttribute: 'assets-object-type-update-attribute',
	AssetsObjectTypeUpdateObject: 'assets-object-type-update-object',
	AssetsObjectUpdateAttribute: 'assets-object-update-attribute',
	AssetsEditObject: 'assets-edit-object',
	// Add other keys here as needed
	ArtifactCreate: 'rovo-artifact-create',
	ScheduledChat: 'ScheduleRovoChatTool',
	ImageSearch: 'image-search',
	MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
	AgenticPlanTool: 'AgenticPlanTool',
	RepositoryChoiceTool: 'RepositoryChoiceTool',
	CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
	CreateKbArticlesCard: 'jsm-atlassian-jsm-kb-validate-draft-articles',
	// Custom Skills
	CreateCustomSkillTool: 'CreateCustomSkillTool',
	UpdateCustomSkillTool: 'UpdateCustomSkillTool',
	// Rovo Data Insights (the backend action key retains the legacy Analytics identifier)
	AtlassianAnalyticsStartSession: 'atlassian-analytics-start-session',
} as const;

export const FOCUS_CREATE_ASK_KEY: (typeof ActionKeys)['FocusCreateAsk'] =
	ActionKeys.FocusCreateAsk;
export const FOCUS_CREATE_ASK_ANTHROPIC_KEY: (typeof ActionKeys)['FocusCreateAskAnthropic'] =
	ActionKeys.FocusCreateAskAnthropic;
export const GOOGLE_DOC_CREATE_KEY: (typeof ActionKeys)['GoogleDocCreate'] =
	ActionKeys.GoogleDocCreate;

export const EXECUTE_PYTHON_KEY = 'execute_python';
export const PLAN_COMPLETE_KEY = 'plan_complete';
export const ASK_QUESTION_KEY = 'ask_question';
// Actions can declare this when their UI replaces or supersedes the footer (e.g. user-answer cards).
export const ACTIONS_HIDING_FOOTER_BUTTONS: ReadonlySet<string> = new Set([
	ASK_QUESTION_KEY,
	PLAN_COMPLETE_KEY,
]);

export const ActionPredicateKeys = {
	DynamicAction: 'dynamicAction',
	Resumption: 'resumption',
} as const;

// Skill Builder's tools, sourced from Integrations Service by the `build-skill` ICR platform skill.
export const CUSTOM_SKILL_IS_TOOL_IDS: Readonly<Record<'create' | 'update', string>> = {
	create: '2252e7f5-51e6-4886-8f49-842f938f567a',
	update: '0aca7f23-fec8-46a7-ae87-107c17a6caee',
};

/** Lookup only: confirmation must preserve the original key to match the stored invocation. */
export const IS_ACTION_ID_TO_KEY: Readonly<Record<string, string>> = {
	[CUSTOM_SKILL_IS_TOOL_IDS.create]: ActionKeys.CreateCustomSkillTool,
	[CUSTOM_SKILL_IS_TOOL_IDS.update]: ActionKeys.UpdateCustomSkillTool,
};

type ActionKeySource = { key?: string | null; actionId?: string | null };

export const resolveActionKey = (action: ActionKeySource): string => {
	if (action?.key) {
		return action.key;
	}
	return (action?.actionId && IS_ACTION_ID_TO_KEY[action.actionId]) || action?.key || '';
};

export const isActionKeyFromActionId = (action: ActionKeySource): boolean =>
	!action?.key && Boolean(resolveActionKey(action));

export const ACTION_RENDER_KEYS = Object.values(ActionKeys) as readonly string[];

export const CONFLUENCE_APPROVAL_ACTION_KEYS: ReadonlySet<string> = new Set([
	ActionKeys.ConfluenceApprovalCreate,
	ActionKeys.ConfluenceApprovalDelete,
	ActionKeys.ConfluenceApprovalGet,
	ActionKeys.ConfluenceApprovalGetHistory,
	ActionKeys.ConfluenceApprovalUpdateCancel,
	ActionKeys.ConfluenceApprovalUpdateDecision,
	ActionKeys.ConfluenceApprovalUpdateDueDate,
	ActionKeys.ConfluenceApprovalUpdateMessage,
	ActionKeys.ConfluenceApprovalUpdateReviewerMembership,
	ActionKeys.ConfluenceApprovalUpdateReviewers,
	ActionKeys.ConfluenceApprovalCreateConvoAi,
	ActionKeys.ConfluenceApprovalReviewApprove,
	ActionKeys.ConfluenceApprovalReviewDeny,
	ActionKeys.ConfluenceApprovalReviewCancel,
	ActionKeys.ConfluenceApprovalReviewClear,
	ActionKeys.ConfluenceApprovalReviewersUpdate,
	ActionKeys.ConfluenceApprovalMessageUpdate,
	ActionKeys.ConfluenceApprovalDueDateUpdate,
	ActionKeys.ConfluenceApprovalSpaceSettingsUpdate,
	ActionKeys.ConfluenceApprovalSiteSettingsUpdate,
]);

export const GENERIC_EXTERNAL_ACTION_ERROR_KEY = 'generic-external-action-error';
export const JIRA_FIND_ISSUES_KEY = 'jira-find-issues';
export const JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY =
	'jira-atlassian-work-item-create-all-field-types';
export const JIRA_SMART_ISSUE_CREATE_BULK_KEY =
	'jira-atlassian-work-item-create-all-field-types-bulk';
export const ADMINHUB_POLICY_CREATE_KEY = 'atlassian:admin:create:policy-preview';
export const ADMINHUB_POLICY_UPDATE_KEY = 'atlassian:admin:update:policy-preview';
export const JSM_CREATE_REQUEST_KEY = 'jsm-create-request';
export const JSM_CREATE_REQUEST_V2_KEY = 'jsm-create-request-v2';
export const CREATE_REQUEST_KEY = 'create-request';
export const JSM_CREATE_EMBEDDED_REQUEST_KEY = 'help-form-submit';
export const JSM_LIVECHAT_KEY = 'jsm-livechat';
export const JIRA_ISSUE_TRANSITION_KEY = 'jira-issue-transition-bulk';
export const JIRA_EPICS_SUGGEST_KEY = 'jira-epics-suggest';
export const JIRA_ISSUE_DELETE_KEY = 'jira-issue-delete';
export const JIRA_ISSUE_MOVE_KEY = 'jira-issue-move';
export const JIRA_ISSUE_ASSIGN_KEY = 'jira-issue-assign-bulk';
export const JIRA_VERSION_CREATE_KEY = 'jira-version-create';
export const JIRA_VIEW_CREATE_AND_CONFIGURE_KEY = 'jira-view-create-and-configure';
export const JIRA_VIEW_SAVE_LIST_VIEW_CONFIG_KEY = 'jira-view-save-list-view-config';
export const ROVO_WHEN_ASSIGNED_TOOL_KEY = 'RovoWhenAssignedTool';
export const ROVO_JIRA_DELEGATION_INTENT_TOOL_KEY = 'RovoJiraDelegationIntentTool';
export const MANAGE_CAPACITY_PLAN_KEY = 'capacity-plan-update-single-action';
export const MANAGE_PLAN_ALLOCATIONS_KEY = 'manage-plan-allocations';
export const JIRA_WORKFLOW_EDITOR = 'jira-workflow-operations';

export const CONFLUENCE_PAGE_CREATE_KEY = 'confluence-page-create';
export const CONFLUENCE_PAGE_COMMENT_KEY = 'confluence-page-comment';
export const CONFLUENCE_PAGE_RENAME_KEY = 'confluence-page-rename';
export const CONFLUENCE_PAGE_ADD_LABEL_KEY = 'confluence-label-create';
export const CONFLUENCE_PAGE_MOVE_KEY = 'confluence-page-move';

export const DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY = 'deep-research-report-confluence-export';

export const IMAGE_SEARCH_KEY = 'image-search';

export const REQUIRE_INFORMATION_TOOL = 'RequireInformationTool';
export const HIRING_MANAGER_TOOL_KEY = 'HiringManagerTool';

export const STUDIO_TRIGGER_SOLUTION_PLAN_KEY = 'studio-trigger-solution-plan';
export const STUDIO_ATLASSIAN_STUDIO_UPDATE_AGENT_DRAFT_KEY =
	'studio-atlassian-studio-update-agent-draft';
export const STUDIO_ATLASSIAN_WORKSPACE_UPDATE_DRAFT_AGENT_KEY =
	'studio-atlassian-workspace-update-draft-agent';

export const UPDATE_AGENT_CONFIGURATION_TOOL_KEY = 'UpdateAgentConfigurationTool';
export const JSM_JOURNEY_BUILDER_KEY = 'jsm-invoke-orchestrator-agent';
export const JSM_CREATE_SURVEY_KEY = 'jsm-atlassian-project-create-jsm-survey';
export const JSM_CREATE_FORM_TEMPLATE_KEY = 'jsm-atlassian-project-create-form-template';
export const JSM_QUEUE_CREATE_KEY = 'jsm-atlassian-project-create-jsm-queue';
export const JSM_QUEUE_GROUP_CREATE_KEY = 'jsm-atlassian-project-create-jsm-queue-group';
export const JSM_QUEUE_UPDATE_KEY = 'jsm-atlassian-project-update-jsm-queue';
export const JSM_QUEUE_GROUP_UPDATE_KEY = 'jsm-atlassian-project-update-jsm-queue-group';
export const JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY =
	'jsm-atlassian-project-update-request-type-groups';
export const JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY = 'jsm-atlassian-request-type-update-workflow';
export const JSM_SLA_CREATE_KEY = 'jsm-create-sla-plugin';
export const JSM_SLA_UPDATE_KEY = 'jsm-update-sla-plugin';
export const JSM_REQUEST_TYPE_CREATE_KEY = 'jsm-atlassian-project-create-jsm-request-type';
export const JSM_REQUEST_TYPE_UPDATED_KEY =
	'jsm-atlassian-project-create-jsm-request-type-with-fields';
export const JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY = 'SuggestAndAddFieldsToRequestType';
export const JSM_CREATE_KB_TOPICS_KEY = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
export const JSM_CREATE_KB_ARTICLES_KEY = 'jsm-atlassian-jsm-kb-validate-draft-articles';

export const STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY = 'studio-automation-trigger-rule-build';
export const STUDIO_AUTOMATION_CREATE_RULE_KEY =
	'automation-platform-atlassian-automation-create-rule';

/**
 * Key for the BE `CreateAgentTool` (see `CreateAgentToolDefinition.kt`).
 * Emitted as an output preview action carrying a `CreateAgentResult` payload.
 */
export const STUDIO_CREATE_AGENT_KEY = 'CreateAgentTool';

/**
 * Key for the BE publish-agent action. Carries an `agentAri` used to preview
 * the agent in the Smart Creation staging area.
 */
export const ROVO_PUBLISH_AGENT_KEY = 'rovo-publish-agent';

/**
 * Canonical Jira Plans action keys, registered against the Integrations Service action ids in
 * `IntegrationsServiceActionMapping` (conversational-ai-platform). The backend sends these
 * verbatim and they are echoed back unchanged on confirm/cancel.
 */
export const JIRA_PLANS_UPDATE_WORK_SOURCE_KEY = 'jira-atlassian-plan-update-work-sources';
export const JIRA_PLANS_ADD_PROGRAM_BOARD_KEY = 'jira-atlassian-plan-add-program-board';
export const JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY = 'jira-atlassian-plan-delete-program-board';
export const JIRA_PLANS_CREATE_WORK_ITEM_KEY = 'jira-atlassian-plan-create-work-item';
export const JIRA_PLANS_MANAGE_FEATURES_KEY = 'jira-atlassian-plan-set-release-enabled';
export const JIRA_PLANS_ADD_DEPENDENCY_KEY = 'jira-atlassian-plan-add-work-item-dependencies';
export const JIRA_PLANS_REMOVE_DEPENDENCY_KEY = 'jira-atlassian-plan-remove-work-item-dependencies';
export const JIRA_PLANS_CREATE_RELEASE_KEY = 'jira-atlassian-plan-create-release';

/**
 * Integrations Service plugin ids, still sent as the action key by the Stratus minions that
 * remain enabled while `rovo_chat_jira_plans_anthropic_migration` is off. Delete these once the
 * Stratus Plans minions are retired.
 */
export const JIRA_PLANS_ADD_PROGRAM_BOARD_STRATUS_KEY = 'jira-plan-add-program-board-plugin';
export const JIRA_PLANS_DELETE_PROGRAM_BOARD_STRATUS_KEY = 'Jira-Plan-Delete-Program-Board-Plugin';
export const JIRA_PLANS_CREATE_RELEASE_STRATUS_KEY = 'Jira-Plan-Create-Release-Plugin';

export const STORE_RECOMMENDATION_ACTION_KEY = 'store-recommendation-card';
export const JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY = 'jira-ham-ai-insights-preview';

export const ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY = 'atlassian-team-atlassian-team-update-archive';

export const SCHEDULED_CHAT_KEY = 'ScheduleRovoChatTool';

export const MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY = 'MultipleChoiceQuestionsTool';

export const AGENTIC_PLAN_TOOL_KEY = 'AgenticPlanTool';

// used for testing only
export const customMessageActionKeys: string[] = [
	JIRA_FIND_ISSUES_KEY,
	JIRA_EPICS_SUGGEST_KEY,
	JIRA_ISSUE_DELETE_KEY,
	JIRA_ISSUE_MOVE_KEY,
];

export type ACTION_KEYS_WITH_CUSTOM_UI_TYPE =
	| (typeof ActionKeys)[keyof typeof ActionKeys]
	| typeof JIRA_VERSION_CREATE_KEY
	| typeof JSM_CREATE_REQUEST_KEY
	| typeof JSM_CREATE_EMBEDDED_REQUEST_KEY
	| typeof JIRA_ISSUE_TRANSITION_KEY
	| typeof JIRA_EPICS_SUGGEST_KEY
	| typeof JIRA_ISSUE_DELETE_KEY
	| typeof JIRA_ISSUE_MOVE_KEY
	| typeof JIRA_ISSUE_ASSIGN_KEY
	| typeof ROVO_WHEN_ASSIGNED_TOOL_KEY
	| typeof ROVO_JIRA_DELEGATION_INTENT_TOOL_KEY
	| typeof CONFLUENCE_PAGE_CREATE_KEY
	| typeof CONFLUENCE_PAGE_COMMENT_KEY
	| typeof JIRA_WORKFLOW_EDITOR
	| typeof DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY
	| typeof REQUIRE_INFORMATION_TOOL
	| typeof GENERIC_EXTERNAL_ACTION_ERROR_KEY
	| typeof JSM_JOURNEY_BUILDER_KEY
	| typeof JSM_CREATE_SURVEY_KEY
	| typeof JIRA_PLANS_UPDATE_WORK_SOURCE_KEY
	| typeof STORE_RECOMMENDATION_ACTION_KEY
	| typeof SCHEDULED_CHAT_KEY
	| typeof FOCUS_CREATE_ASK_KEY
	| typeof MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY
	| typeof AGENTIC_PLAN_TOOL_KEY;
